import { render, staticRenderFns } from "./storeForm.vue?vue&type=template&id=d3d81b48"
import script from "./storeForm.vue?vue&type=script&lang=js"
export * from "./storeForm.vue?vue&type=script&lang=js"
import style0 from "./storeForm.vue?vue&type=style&index=0&id=d3d81b48&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3d81b48')) {
      api.createRecord('d3d81b48', component.options)
    } else {
      api.reload('d3d81b48', component.options)
    }
    module.hot.accept("./storeForm.vue?vue&type=template&id=d3d81b48", function () {
      api.rerender('d3d81b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjGraph/storeForm.vue"
export default component.exports